import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';


interface MyFeedbackListProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
}

interface MyFeedbackListState {
    loading: boolean;
    error: any
    pageLoaded: any
    feedbackList: any[]
    feedbackFilterIndex: number
    navList: any
    navCurrentIndex: any
}
@inject('app', 'thread', 'user')
@observer
class MyFeedbackList extends BasePage<MyFeedbackListProps, MyFeedbackListState> {
    namespace = 'usersFeedbacksList';
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        feedbackList: [],   // 反馈列表
        feedbackFilterIndex: 0,
        navList: [
            { name: '全部', id: '', value: '' },
            { name: '已解决', id: 3, value: '3' },
            { name: '已回复', id: 2, value: '2' },
            { name: '待处理', id: 1, value: '1' },
            { name: '未解决', id: 0, value: '0' },
        ],
        navCurrentIndex: 0,
    };
    componentDidMount() {
        this.getFeedbackList();
        super.componentDidMount();
    }

    // 获取筛选参数值：取当前 navList 项的 value
    getFeedbackFilterValue = () => {
        const { app, user } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc' && user) {
            this.props.history.push(`/user/${user?.userInfo?.code}?tab=5`);
            return;
        }
        const { navList, navCurrentIndex } = this.state;
        const currentNav = navList[navCurrentIndex];
        if (!currentNav || currentNav.value === undefined || currentNav.value === '') {
            return null;
        }
        return Number(currentNav.value);
    }

    // 加载反馈列表
    getFeedbackList = () => {
        const { thread } = this.props;
        const filterValue = this.getFeedbackFilterValue();
        if (thread) {
            let params: any = {
                "page[number]": 1,
                "page[size]": 20,
                "filter[mine]": 1,
            };
            if (filterValue !== null) {
                params['filter[solveState]'] = filterValue;
            }
            thread.getFeedbackList(params, this.namespace);
        }
    }

    // 只获取数据，不渲染
    getFeedbackListData = () => {
        const { thread } = this.props;
        if (!thread || !thread.listStore) return [];
        const list = thread.listStore.lists[this.namespace];
        if (!list) return [];
        return thread.listStore.getList({ namespace: this.namespace });
    }

    // 导航切换
    navClick = (item: any, index: any) => {
        const { thread } = this.props;
        this.setState({
            navCurrentIndex: index,
            feedbackFilterIndex: index,
        }, () => {
            // 清空列表并重新加载
            thread?.listStore?.clearList({ namespace: this.namespace });
            this.getFeedbackList();
        });
    }

    // 分页加载更多
    handleLoadMore = () => {
        const { thread } = this.props;

        if (!thread) return;

        const list = thread.listStore.lists[this.namespace];

        if (!list) return;

        if (!list.hasMore) {
            return;
        }

        if (list.loading) {
            return;
        }

        const currentPage = list.attribs?.page || 1;
        const nextPage = currentPage + 1;
        const filterValue = this.getFeedbackFilterValue();

        let params: any = {
            "page[number]": nextPage,
            "page[size]": 20,
            "filter[mine]": 1,
        };
        if (filterValue !== null) {
            params['filter[solveState]'] = filterValue;
        }
        thread.getFeedbackList(params, this.namespace);
    }

    render() {
        const { app, thread } = this.props;
        const { navList, navCurrentIndex } = this.state;
        const platform = app?.platform || 'h5';
        // 获取列表数据和状态
        const listStore = thread?.listStore;
        const list = listStore?.lists[this.namespace];
        const feedbackList = listStore?.getList({ namespace: this.namespace }) || [];
        const loading = list?.loading || false;
        const hasMore = list?.hasMore ?? true;
        const dataProps = {
            feedbackList,
            loading,
            hasMore,
            onLoadMore: this.handleLoadMore,
            navList,
            navCurrentIndex,
            navClick: this.navClick,
            feedbackFilterIndex: this.state.feedbackFilterIndex,
        };

        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        } else {
            return (<div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (<PC
                    {...this.props}
                    {...dataProps}
                ></PC>) : (
                        <H5
                            {...this.props}
                            {...dataProps}
                        ></H5>
                    )}
            </div>)
        }

    }
}

export default withRouter(MyFeedbackList);
